import React, { Component } from 'react';
import http from '../modules/api';

import TextInput from "../modules/common/TextInput";
import SelectBoxV2 from '../modules/common/SelectBoxV2';
import CheckBox from '../modules/common/CheckBox';

import SaveDialogV2 from '../modules/dialogs/SaveDialogV2';
import WarningDialog from "../modules/dialogs/WarningDialog";
import RoboMDAICopywriterModal from './component/RoboMDAICopywriterModal';

const params = new URLSearchParams(window.location.search);
const COPYWRITER_SETTING_TUTORIAL_EVENT = "instagram-tutorial:copywriter-setting-action";

const COPYWRITER_SELECTED_CONTENT_STORAGE_KEY =
  "instagram_copywriter_selected_content";
const COPYWRITER_SELECTED_CONTENT_APPLY_PARAM =
  "apply_copywriter_content";

const COPYWRITER_AUTOMATION_PATHS = Object.freeze({
  AI_IMAGE: "/shop/instagram/InstagramCreateAiImageAutomation",
  PRODUCT: "/shop/instagram/InstagramCreateProductAutomation",
});

const FACEBOOK_APP_ID = '780456611206591';
const BASEDOMAIN = document.domain.indexOf("127.0.0.1") >= 0 ? 'https://127.0.0.1:8092' : "https://robomd.io";
const REDIRECT_URI = BASEDOMAIN + '/rest/shop/instagram/callbackForRefleshParent';
const SCOPES = [
  'pages_show_list',
  'business_management',
  'instagram_basic',
  'instagram_content_publish',
  'instagram_manage_insights',
  'public_profile'
].join(',');

class InstagramCopywriterSetting extends Component {
  constructor(props) {
    super(props);

    this.automationMenuRef = React.createRef();

    this.state = {
      preset_seq: params.get('preset_seq'),
      presetTitle: '',
      // 제목을 직접 입력하지 않을 때 사용할 자동 제목 (플레이스홀더)
      suggestedPresetTitle: '카피라이터_년도월일_번호',
      isDataLearningOn: false,
      industry: '',
      target: '',
      language: 'ko',
      objective: '',
      ctaPosition: 'bottom',
      ctaText: '',
      extraPrompt: '',
      learningData: 'multi', // multi, text, image
      
      // 다중 생성 카드 체크 상태
      cardsChecked: {
        'ref-basic': true,
        'ref-myfeed': false,
        'ref-custom': false,
      },
      
      // 내부 아이템 선택 상태
      selectedInnerItems: {
        'ref-basic': 0,
        'ref-custom': 0,
      },

      // 커스텀 뱅크 관련 상태
      customTextInput: '',
      customItems: [
        // '매일 아침 10분 더 자게 해주는 26도 헤어만의 시그니처 단발펌! ⏰ 드라이기 하나면 미용실 다녀온 퀄리티 그대로 연출 가능해요.'
      ],

      // 계정 연동
      add_account_list: [],
      account_list: [],
      account_list_v2: [],
      default_ig_access_seq: "",
      selected_ig_access_seq: "",
      selectedAccount: null,
      accountConnected: false,

      feedCaptions: [],
      selectedLearnedFeedCaptions: [],
      selectedLearnedFeedCaptionsCnt: 0,

      isRunModalOpen: false,
      runPresetSeq: null,
      runModalKey: 0,
      isSavingPreset: false,
      automationMenuOpen: false,

      // 경고 다이얼로그
      warning_dialog_show_state: false,
      warning_dialog_content: '',
      warning_dialog_button_list: [],
    };
  }

  componentDidMount() {
    window.addEventListener(COPYWRITER_SETTING_TUTORIAL_EVENT, this.handleCopywriterSettingTutorialAction);
    if (this.state.preset_seq) {
      this.loadPresetData();
    } else {
      this.loadSuggestedPresetTitle();
      this.loadReferenceBankList();
    }
    this.loadInstagramAccountList();

    window.addEventListener("message", this.handleInstagramAccountMessage);
    document.addEventListener("mousedown", this.handleDocumentMouseDown);
  }

  componentWillUnmount() {
    window.removeEventListener(COPYWRITER_SETTING_TUTORIAL_EVENT, this.handleCopywriterSettingTutorialAction);
    window.removeEventListener("message", this.handleInstagramAccountMessage);
    document.removeEventListener("mousedown", this.handleDocumentMouseDown);
  }

  handleCopywriterSettingTutorialAction = (event) => {
    const action = event?.detail?.action;

    const ensureTutorialSnapshot = () => {
      if (this.copywriterSettingTutorialSnapshot) return;
      this.copywriterSettingTutorialSnapshot = {
        cardsChecked: { ...(this.state.cardsChecked || {}) },
      };
    };

    const showVoice = (voiceKey) => {
      ensureTutorialSnapshot();
      this.setState((prev) => ({
        cardsChecked: {
          ...(prev.cardsChecked || {}),
          'ref-basic': voiceKey === 'ref-basic',
          'ref-myfeed': voiceKey === 'ref-myfeed',
          'ref-custom': voiceKey === 'ref-custom',
        },
      }));
    };

    if (action === "SHOW_VOICE_BASIC") {
      showVoice('ref-basic');
      return;
    }

    if (action === "SHOW_VOICE_MYFEED") {
      showVoice('ref-myfeed');
      return;
    }

    if (action === "SHOW_VOICE_CUSTOM") {
      showVoice('ref-custom');
      return;
    }

    if (action === "RESTORE") {
      if (!this.copywriterSettingTutorialSnapshot) return;
      const snapshot = this.copywriterSettingTutorialSnapshot;
      this.copywriterSettingTutorialSnapshot = null;
      this.setState({ cardsChecked: { ...(snapshot.cardsChecked || {}) } });
    }
  };

  handleDocumentMouseDown = (event) => {
    const menuElement = this.automationMenuRef.current;

    if (
      this.state.automationMenuOpen &&
      menuElement &&
      !menuElement.contains(event.target)
    ) {
      this.setState({ automationMenuOpen: false });
    }
  };

  // 서버가 제안하는 다음 자동 제목을 조회한다. 조회만으로 번호를 예약하지는 않는다.
  loadSuggestedPresetTitle = async () => {
    try {
      const response = await http.get('/rest/shop/instagram/copywriter/preset/next-title');
      const data = response?.data || {};
      if (data.status === 'success' && data.preset_title) {
        this.setState({ suggestedPresetTitle: data.preset_title });
      } else {
        this.setState({ suggestedPresetTitle: '카피라이터_년도월일_번호' });
      }
    } catch (error) {
      console.error('자동 제목 조회 실패:', error);
      this.setState({ suggestedPresetTitle: '카피라이터_년도월일_번호' });
    }
  };

  // 기존 원본 소스의 포커스 이벤트 핸들러 복구
  handleFocus = (e) => {
    if (e.target.id === 'presetTitle' && this.state.presetTitle === 'A 스타일 (여름 이벤트 피드 본문용)') {
      this.setState({ presetTitle: '' });
    }
    // 제목 플레이스홀더는 포커스 중에도 유지해 미입력 저장 제목을 확인할 수 있게 한다.
    if (e.target.id !== 'presetTitle') e.target.placeholder = '';
  };

  handleBlur = (e) => {
    const dataPlaceholder = e.target.getAttribute('data-placeholder');
    if (dataPlaceholder) {
      e.target.placeholder = dataPlaceholder;
    }
  };

  // 상태 관리 통합 핸들러
  handleStateChange = (key, value) => {
    this.setState({ [key]: value });
  }

  closeWarningDialog = () => {
    this.setState({ warning_dialog_show_state: false });
  };

  showWarningDialog = (content) => {
    this.setState({
      warning_dialog_show_state: true,
      warning_dialog_content: content,
      warning_dialog_button_list: [{
        title: "확인",
        type: "1",
        event_method: this.closeWarningDialog,
      }],
    });
  };

  toggleDataLearning = () => {
    this.setState((prevState) => ({
      isDataLearningOn: !prevState.isDataLearningOn,
    }));
  };

  handleCardCheck = (cardId, isChecked) => {
    this.setState((prevState) => ({
      cardsChecked: {
        ...prevState.cardsChecked,
        [cardId]: isChecked,
      },
    }));
  };

  handleInnerItemSelect = (cardId, index) => {
    this.setState((prevState) => ({
      selectedInnerItems: {
        ...prevState.selectedInnerItems,
        [cardId]: index,
      },
    }));
  };

  handleAddCustomRef = () => {
    const { customTextInput } = this.state;
    const text = (customTextInput || '').trim();

    if (!text) {
      this.showWarningDialog("레퍼런스로 사용할 피드 문구를 입력해주세요.");
      return;
    }

    http.post('/rest/shop/instagram/aiCopywriter/referenceBank/insert', {
      custom_reference_text: text
    })
      .then((response) => {
        const result = response?.data;

        if (result?.result === 'success') {
          this.setState({ customTextInput: '' }, () => {
            this.loadReferenceBankList();
          });
        } else {
          alert(result?.message || '커스텀 뱅크 저장에 실패했습니다.');
        }
      })
      .catch((error) => {
        console.error('커스텀 뱅크 추가 중 오류 발생:', error);
        alert('커스텀 뱅크 저장 중 오류가 발생했습니다.');
      });
  };

  handleDeleteCustomRef = (e, index) => {
    e.stopPropagation();

    const target = (this.state.customItems || [])[index];
    if (!target) return;

    // 아직 저장 안 된 임시 항목 방어
    if (!target.custom_reference_seq) {
      this.setState((prev) => {
        const newItems = [...(prev.customItems || [])];
        newItems.splice(index, 1);

        const reordered = newItems.map((item, idx) => ({
          ...item,
          sort_order: idx,
        }));

        let selectedIndex = prev.selectedInnerItems['ref-custom'] || 0;

        if (selectedIndex === index) {
          selectedIndex = reordered.length > 0 ? Math.max(0, index - 1) : 0;
        } else if (selectedIndex > index) {
          selectedIndex -= 1;
        }

        return {
          customItems: reordered,
          selectedInnerItems: {
            ...prev.selectedInnerItems,
            'ref-custom': selectedIndex,
          },
        };
      });
      return;
    }

    http.post('/rest/shop/instagram/aiCopywriter/referenceBank/delete', {
      custom_reference_seq: target.custom_reference_seq
    })
      .then((response) => {
        const result = response?.data;

        if (result?.result === 'success') {
          this.loadReferenceBankList();
        } else {
          alert(result?.message || '커스텀 뱅크 삭제에 실패했습니다.');
        }
      })
      .catch((error) => {
        console.error('커스텀 뱅크 삭제 중 오류 발생:', error);
        alert('커스텀 뱅크 삭제 중 오류가 발생했습니다.');
      });
  };

  loadReferenceBankList = (selectedReferenceSeqList = []) => {
    http.post('/rest/shop/instagram/aiCopywriter/referenceBank/list', {})
      .then((response) => {
        const list = Array.isArray(response?.data?.list) ? response.data.list : [];

        this.setState((prevState) => {
          const prevCustomItems = Array.isArray(prevState.customItems) ? prevState.customItems : [];
          const prevSelectedInnerItems = prevState.selectedInnerItems || {};
          const prevSelectedCustomIndex = Number(prevSelectedInnerItems['ref-custom'] ?? 0);

          const prevSelectedCustomItem =
            prevCustomItems[prevSelectedCustomIndex] &&
            prevCustomItems[prevSelectedCustomIndex].custom_reference_seq
              ? prevCustomItems[prevSelectedCustomIndex]
              : null;

          const prevSelectedCustomReferenceSeq = prevSelectedCustomItem
            ? String(prevSelectedCustomItem.custom_reference_seq)
            : '';

          const selectedReferenceSeqSet = new Set(
            (selectedReferenceSeqList || []).map(v => String(v))
          );

          const nextCustomItems = list.map((item, index) => ({
            custom_reference_seq: item.custom_reference_seq,
            custom_reference_text: item.custom_reference_text || '',
            selected_yn: 'N',
            sort_order: index,
          }));

          let nextSelectedCustomIndex = -1;

          // 1. 프리셋 조회에서 내려온 selected_yn = 'Y' 항목을 우선 반영
          if (selectedReferenceSeqSet.size > 0) {
            nextSelectedCustomIndex = nextCustomItems.findIndex(
              (item) => selectedReferenceSeqSet.has(String(item.custom_reference_seq))
            );
          }

          // 2. 프리셋 선택값이 없을 때만 화면에서 이미 선택 중이던 항목 유지
          if (nextSelectedCustomIndex < 0 && prevSelectedCustomReferenceSeq) {
            nextSelectedCustomIndex = nextCustomItems.findIndex(
              (item) => String(item.custom_reference_seq) === prevSelectedCustomReferenceSeq
            );
          }

          // 3. 그래도 없으면 0으로
          if (nextSelectedCustomIndex < 0) {
            nextSelectedCustomIndex = 0;
          }

          const finalCustomItems = nextCustomItems.map((item, index) => ({
            ...item,
            selected_yn: index === nextSelectedCustomIndex ? 'Y' : 'N',
          }));

          return {
            customItems: finalCustomItems,
            selectedInnerItems: {
              ...prevSelectedInnerItems,
              'ref-custom': nextSelectedCustomIndex,
            },
          };
        });
      })
      .catch((error) => {
        console.error('커스텀 레퍼런스 뱅크 조회 중 오류 발생:', error);
      });
  };

  loadPresetData = () => {
    http.get('/rest/shop/instagram/copywriter/preset/info?preset_seq=' + this.state.preset_seq)
      .then((response) => {
        if (response?.data?.status === 'success' && response?.data?.result) {
          const data = response.data.result;
          const learnedCaptionList = data.learned_caption_list || [];
          const customReferenceList = Array.isArray(data.custom_reference_list)
            ? data.custom_reference_list
            : [];

          const selectedCustomIndex = customReferenceList.findIndex(
            item => String(item.selected_yn || '').toUpperCase() === 'Y'
          );

          const selectedReferenceSeqList = customReferenceList
          .filter(item => String(item.selected_yn || '').toUpperCase() === 'Y')
          .map(item => item.custom_reference_seq);

          this.setState({
            presetTitle: data.preset_title || '',
            industry: data.industry || '',
            target: data.target || '',
            language: data.language_code || 'ko',
            objective: data.objective || '',

            cardsChecked: {
              'ref-basic': data.use_basic_voice == 1 || data.use_basic_voice === true || data.use_basic_voice === 'Y',
              'ref-myfeed': data.use_myfeed_voice == 1 || data.use_myfeed_voice === true || data.use_myfeed_voice === 'Y',
              'ref-custom': data.use_custom_voice == 1 || data.use_custom_voice === true || data.use_custom_voice === 'Y',
            },

            selectedInnerItems: {
              'ref-basic': data.basic_voice_index || 0,
              'ref-custom': selectedCustomIndex >= 0 ? selectedCustomIndex : 0,
            },

            extraPrompt: data.extra_prompt || '',
            isDataLearningOn:
              data.is_data_learning_on == 1 ||
              data.is_data_learning_on === true ||
              data.is_data_learning_on === 'Y',

            learningData: data.learning_data_type || 'multi',
            ctaPosition: data.call_to_action_position || 'bottom',
            ctaText: data.call_to_action_text || '',
            customItems: customReferenceList,
            selected_ig_access_seq: data.instagram_access_token_seq || "",
            selectedLearnedFeedCaptions: learnedCaptionList,
            selectedLearnedFeedCaptionsCnt: learnedCaptionList.length,
          }, () => {
            this.loadReferenceBankList(selectedReferenceSeqList);
            
            const shouldLoadMyFeed =
              this.state.cardsChecked['ref-myfeed'] && this.getActiveIgSeq();

            if (shouldLoadMyFeed) {
              this.fetchAllInstagramMedia(false, this.getActiveIgSeq());
            }
          });
        } else {
          alert("존재하지 않는 설정입니다.");
        }
      })
      .catch((error) => {
        console.error('설정 조회 중 오류 발생:', error);
      });
  };

  getActiveIgSeq = () => {
    return this.state.selected_ig_access_seq || this.state.default_ig_access_seq || "";
  };

  validateBeforeSave = () => {
    const {
      presetTitle,
      cardsChecked,
      customItems,
      selectedInnerItems,
      accountConnected,
      selected_ig_access_seq,
      default_ig_access_seq,
      selectedLearnedFeedCaptions,
      isDataLearningOn,
      learningData,
      extraPrompt,
      ctaText,
      objective,
      industry,
      target,
    } = this.state;

    const title = (presetTitle || '').trim();
    const industryText = (industry || '').trim();
    const targetText = (target || '').trim();
    const objectiveText = (objective || '').trim();

    const selectedVoiceCount = Object.values(cardsChecked || {}).filter(Boolean).length;
    const selectedIgSeq = this.getActiveIgSeq();
    const customList = Array.isArray(customItems) ? customItems : [];
    const selectedMyFeedList = Array.isArray(selectedLearnedFeedCaptions) ? selectedLearnedFeedCaptions : [];
    const customSelectedIndex = Number(selectedInnerItems?.['ref-custom'] ?? 0);

    if (!industryText) {
      this.showWarningDialog("업종 특성을 입력해주세요.");
      return false;
    }

    if (!targetText) {
      this.showWarningDialog("주요 타겟 고객을 입력해주세요.");
      return false;
    }

    if (!objectiveText) {
      this.showWarningDialog("생성 목적을 입력해주세요.");
      return false;
    }

    if (title.length > 100) {
      this.showWarningDialog("AI 카피라이터 제목은 100자 이하로 입력해주세요.");
      return false;
    }

    if (industryText.length > 200) {
      this.showWarningDialog("업종 특성은 200자 이하로 입력해주세요.");
      return false;
    }

    if (targetText.length > 200) {
      this.showWarningDialog("주요 타겟 고객은 200자 이하로 입력해주세요.");
      return false;
    }

    // if (selectedVoiceCount === 0) {
    //   alert("브랜드 보이스를 최소 1개 이상 선택해주세요.");
    //   return false;
    // }

    if (cardsChecked['ref-myfeed']) {
      if (!accountConnected) {
        this.showWarningDialog("내 기존 피드 AI 보이스를 사용하려면 인스타그램 계정 연동이 필요합니다.");
        return false;
      }

      if (!selectedIgSeq) {
        this.showWarningDialog("학습할 인스타그램 계정을 선택해주세요.");
        return false;
      }

      if (selectedMyFeedList.length === 0) {
        this.showWarningDialog("내 기존 피드 AI 보이스를 사용하려면 학습 기준 게시물을 1개 선택해주세요.");
        return false;
      }
    }

    if (cardsChecked['ref-custom']) {
      if (customList.length === 0) {
        this.showWarningDialog("커스텀 뱅크 AI 보이스를 사용하려면 레퍼런스 문구를 1개 이상 추가해주세요.");
        return false;
      }

      if (customSelectedIndex < 0 || customSelectedIndex >= customList.length) {
        this.showWarningDialog("커스텀 뱅크에서 학습 기준 문구를 1개 선택해주세요.");
        return false;
      }

      const hasEmptyCustomText = customList.some(
        (item) => !String(item?.custom_reference_text || '').trim()
      );

      if (hasEmptyCustomText) {
        this.showWarningDialog("비어 있는 커스텀 레퍼런스 문구가 있습니다.");
        return false;
      }
    }

    if (isDataLearningOn && !['multi', 'text', 'image'].includes(learningData)) {
      this.showWarningDialog("데이터 학습 방식을 선택해주세요.");
      return false;
    }

    if (objectiveText.length > 1000) {
      this.showWarningDialog("생성 목적은 1000자 이하로 입력해주세요.");
      return false;
    }

    if ((extraPrompt || '').length > 2000) {
      this.showWarningDialog("AI 추가 명령 프롬프트는 2000자 이하로 입력해주세요.");
      return false;
    }

    if ((ctaText || '').length > 300) {
      this.showWarningDialog("CTA 문구는 300자 이하로 입력해주세요.");
      return false;
    }

    return true;
  };

  buildPresetSavePayload = () => {
    const {
      presetTitle, isDataLearningOn, cardsChecked, selectedInnerItems,
      customItems, industry, target, language, objective,
      ctaPosition, ctaText, extraPrompt, learningData
    } = this.state;

    const customReferenceList = (customItems || []).map((item, index) => ({
      custom_reference_seq: item.custom_reference_seq,
      selected_yn: index === selectedInnerItems['ref-custom'] ? 'Y' : 'N'
    }));

    return {
      preset_seq: this.state.preset_seq,
      // 빈 제목은 서버에서 날짜별 자동 제목으로 확정한다.
      preset_title: (presetTitle || '').trim(),
      industry: industry || '',
      target: target || '',
      language_code: language || 'ko',
      objective: objective || '',
      use_basic_voice: cardsChecked['ref-basic'] ? 1 : 0,
      basic_voice_index: selectedInnerItems['ref-basic'] || 0,
      use_myfeed_voice: cardsChecked['ref-myfeed'] ? 1 : 0,
      use_custom_voice: cardsChecked['ref-custom'] ? 1 : 0,
      custom_voice_index: selectedInnerItems['ref-custom'] || 0,
      extra_prompt: extraPrompt || '',
      is_data_learning_on: isDataLearningOn ? 1 : 0,
      learning_data_type: learningData || 'multi',
      call_to_action_position: ctaPosition || 'bottom',
      call_to_action_text: ctaText || '',
      custom_reference_list: customReferenceList,
      selectedLearnedFeedCaptions: this.state.selectedLearnedFeedCaptions,
      instagram_access_token_seq: this.getActiveIgSeq(),
    };
  };

  savePreset = async (runAfterSave = false, automationType = "") => {
    if (this.state.isSavingPreset) return false;
    if (!this.validateBeforeSave()) return false;

    const payload = this.buildPresetSavePayload();
    const invalidCustomReference = (payload.custom_reference_list || []).some(
      item => !item.custom_reference_seq
    );

    if (this.state.cardsChecked['ref-custom'] && invalidCustomReference) {
      this.showWarningDialog("저장되지 않은 커스텀 뱅크 문구가 있습니다.");
      return false;
    }

    this.setState({
      isSavingPreset: true,
      save_dialog_show_state: true,
      save_dialog_content: "저장중 입니다.",
      save_dialog_button_list: [{ title: "확인", type: "1", display_yn: "N" }],
    });

    try {
      const response = await http.post('/rest/shop/instagram/copywriter/preset', payload);
      if (response?.data?.status !== 'success') {
        throw new Error(response?.data?.message || '저장에 실패했습니다.');
      }

      const nextSeq = response?.data?.preset_seq || this.state.preset_seq;
      if (!nextSeq) throw new Error('저장된 AI 카피라이터 번호를 확인하지 못했습니다.');
      // 제목을 입력하지 않았다면 서버가 확정한 자동 제목으로 화면 상태를 동기화한다.
      const savedPresetTitle = response?.data?.preset_title || payload.preset_title;

      if (window.opener) {
        window.opener.postMessage(
          { type: "copywriter_setting_saved", result: true, preset_seq: nextSeq },
          window.location.origin
        );
      }

      const url = new URL(window.location.href);
      url.searchParams.set("preset_seq", nextSeq);
      window.history.replaceState({}, "", url);

      // 저장 후 비운 제목을 다시 편집할 때 플레이스홀더에 이전 번호가 남지 않도록 갱신한다.
      if (!automationType) this.loadSuggestedPresetTitle();

      if (automationType) {
        const targetPath = COPYWRITER_AUTOMATION_PATHS[automationType];

        if (!targetPath) {
          throw new Error("이동할 자동화 설정 화면을 확인하지 못했습니다.");
        }

        await new Promise((resolve) => {
          this.setState({
            preset_seq: nextSeq,
            presetTitle: savedPresetTitle,
            automationMenuOpen: false,
            isSavingPreset: false,
            save_dialog_show_state: false,
          }, resolve);
        });

        window.location.href =
          `${targetPath}?copywriter_preset_seq=${encodeURIComponent(nextSeq)}`;

        return true;
      }

      if (runAfterSave) {
        await new Promise((resolve) => {
          this.setState((prev) => ({
            preset_seq: nextSeq,
            presetTitle: savedPresetTitle,
            runPresetSeq: nextSeq,
            isRunModalOpen: true,
            runModalKey: prev.runModalKey + 1,
            isSavingPreset: false,
            save_dialog_show_state: false,
          }), resolve);
        });
      } else {
        this.setState({
          preset_seq: nextSeq,
          presetTitle: savedPresetTitle,
          isSavingPreset: false,
          save_dialog_show_state: true,
          save_dialog_content: "저장되었습니다.",
          save_dialog_button_list: [{
            title: "확인",
            type: "1",
            event_method: () => this.setState({ save_dialog_show_state: false })
          }],
        });
      }

      return true;
    } catch (error) {
      console.error('설정 저장 중 오류 발생:', error);
      this.setState({
        isSavingPreset: false,
        save_dialog_show_state: true,
        save_dialog_content: error?.message || "저장에 실패했습니다.",
        save_dialog_button_list: [{
          title: "확인",
          type: "1",
          event_method: () => this.setState({ save_dialog_show_state: false })
        }],
      });
      return false;
    }
  };

  handleSavePreset = () => this.savePreset(false);

  handleSaveAndRunPreset = () => this.savePreset(true);

  handleSaveAndGoAutomation = (automationType) => {
    this.setState({ automationMenuOpen: false }, () => {
      this.savePreset(false, automationType);
    });
  };

  handleSelectedContentRegister = (
    selectedText,
    selectedRecommendations = [],
    copywriterContext = {}
  ) => {
    const content = Array.isArray(selectedText)
      ? selectedText
          .map((item) => String(item || "").trim())
          .filter(Boolean)
          .join("\n\n")
      : String(selectedText || "").trim();

    if (!content) {
      this.showWarningDialog("콘텐츠에 사용할 문구를 선택해주세요.");
      return false;
    }

    const popupPresetSeq = String(
      copywriterContext.copywriter_preset_seq || ""
    ).trim();

    const fallbackPresetSeq = String(
      this.state.runPresetSeq || this.state.preset_seq || ""
    ).trim();

    const copywriterPresetSeq =
      popupPresetSeq || fallbackPresetSeq || null;

    const recommendationHistorySeq = (selectedRecommendations || [])
      .map((item) => item?.copywriter_history_seq)
      .find(Boolean);

    const transferPayload = {
      caption: content,
      copywriter_preset_seq: copywriterPresetSeq,
      copywriter_preset_title:
        copywriterContext.copywriter_preset_title ||
        this.state.presetTitle ||
        null,
      copywriter_history_seq:
        copywriterContext.copywriter_history_seq ||
        recommendationHistorySeq ||
        null,
    };

    sessionStorage.setItem(
      COPYWRITER_SELECTED_CONTENT_STORAGE_KEY,
      JSON.stringify(transferPayload)
    );

    window.location.href =
      `/shop/instagram/InstagramCreatePost?${COPYWRITER_SELECTED_CONTENT_APPLY_PARAM}=Y`;

    return true;
  };

  closeRunModal = () => {
    this.setState({ isRunModalOpen: false });
  };

  /* 내 피드 학습 */
  loadInstagramAccountList = (token_id) => {
    const url = token_id
      ? "/rest/shop/instagram/profile/list?token_id=" + token_id
      : "/rest/shop/instagram/profile/list";

    http.get(url)
      .then((res) => {
        const list = Array.isArray(res?.data?.list) ? res.data.list : [];
        const account_list = this.buildIgAccountOptions(list);
        const account_list_v2 = this.buildIgAccountOptionsV2(list);
        const defaultSeq = this.buildIgDefaultAccount(list) || "";
        const selectedSeq = this.state.selected_ig_access_seq || defaultSeq || "";

        const targetAcc =
          (account_list_v2 || []).find(acc => String(acc.value) === String(selectedSeq)) || null;

        this.setState({
          add_account_list: list,
          account_list,
          account_list_v2,
          default_ig_access_seq: defaultSeq,
          accountConnected: list.length > 0,
          selectedAccount: targetAcc,
          selected_ig_access_seq: selectedSeq,
        }, () => {
          const igSeq = this.getActiveIgSeq();
          if (igSeq) {
            this.fetchAllInstagramMedia(!!token_id, igSeq);
          }
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  buildIgAccountOptions = (apiPayload) => {
    const src = (apiPayload && (apiPayload.list || apiPayload)) || [];
    const opts = [];

    src.forEach((fb) => {
      const fbName = fb.facebook_username || "(이름 없음)";
      const igList = fb.instagram_account_list || [];

      igList.forEach((ig) => {
        const v = String(ig.instagram_access_token_seq ?? "");
        if (!v) return;

        const uname = ig.username ? `@${ig.username}` : "(계정명 없음)";
        opts.push({
          value: v,
          title: `${fbName} / ${uname}`,
        });
      });
    });

    return opts;
  };

  buildIgAccountOptionsV2 = (apiPayload) => {
    const src = (apiPayload && (apiPayload.list || apiPayload)) || [];
    const opts = [];

    src.forEach((fb) => {
      const igList = fb.instagram_account_list || [];

      igList.forEach((ig) => {
        const v = String(ig.instagram_access_token_seq ?? "");
        if (!v) return;

        const uname = ig.username ? `${ig.username}` : "(계정명 없음)";
        opts.push({
          value: v,
          title: `${uname}`,
          profile_picture_url: ig.profile_picture_url || null,
        });
      });
    });

    return opts;
  };

  buildIgDefaultAccount = (apiPayload) => {
    const src = (apiPayload && (apiPayload.list || apiPayload)) || [];

    for (const fb of src) {
      const igList = fb.instagram_account_list || [];

      const found = igList.find((ig) => {
        const v = String(ig.instagram_access_token_seq ?? "");
        return v && ig.default_yn === "Y";
      });

      if (found) {
        return String(found.instagram_access_token_seq);
      } else if (igList.length > 0) {
        return String(igList[0].instagram_access_token_seq ?? "");
      }
    }

    return "";
  };

  handleConnectAccount = () => {
    const authUrl =
      `https://www.facebook.com/v24.0/dialog/oauth?` +
      `client_id=${FACEBOOK_APP_ID}` +
      `&redirect_uri=${encodeURIComponent(REDIRECT_URI)}` +
      `&scope=${SCOPES}` +
      `&response_type=code`;

    window.open(authUrl, "_blank", "width=600,height=800");
  };

  onChangeAccount = (text, value) => {
    const targetAcc =
      (this.state.account_list_v2 || []).find(acc => String(acc.value) === String(value)) || null;

    this.setState(
      {
        selected_ig_access_seq: value,
        selectedAccount: targetAcc,
        selectedLearnedFeedCaptions: [],
        selectedLearnedFeedCaptionsCnt: 0,
      },
      () => {
        const igSeq = this.getActiveIgSeq();
        if (igSeq) {
          this.fetchAllInstagramMedia(true, igSeq);
        }
      }
    );
  };

  fetchAllInstagramMedia = (is_init = false, instagram_access_token_seq, pageLimit = 100, maxItems = 5000) => {
    if (!instagram_access_token_seq) {
      return;
    }

    http.get(`/rest/shop/instagram/${instagram_access_token_seq}/media/all`, {
      params: {
        pageLimit,
        maxItems,
      },
    })
      .then((response) => {
        const res = response.data;

        if (res && res.status === "success") {
          const feedCaptions = (res.data.data || [])
            .filter((item) => this.cleanCaption(item.caption))
            .map((item) => ({
              instagram_media_id: item.id,
              caption: this.cleanCaption(item.caption),
              timestamp: item.timestamp,
            }));

          this.setState({
            mediaList: res.data.data || [],
            feedCaptions,
            selectedLearnedFeedCaptions: is_init ? [] : this.state.selectedLearnedFeedCaptions,
            selectedLearnedFeedCaptionsCnt: is_init ? 0 : this.state.selectedLearnedFeedCaptionsCnt,
          });
        }
      })
      .catch((error) => {
        console.error("Instagram 미디어 조회 오류:", error);
      });
  };

  cleanCaption = (text) => {
    if (!text) return "";

    let caption = text;

    // 문장 시작 부분에 붙어있는 해시태그 제거
    // 예: "#여행 #카페 오늘 날씨 좋다" → "오늘 날씨 좋다"
    caption = caption.replace(/^\s*(#[A-Za-z0-9가-힣_]+\s*)+/gm, "");

    // 본문 중간 또는 끝에 있는 @멘션 제거
    // 예: "오늘 @friend 와 카페" → "오늘 와 카페"
    caption = caption.replace(/(^|\s)@[A-Za-z0-9._]+/g, "$1");

    // 문장 뒤에 붙은 해시태그 제거 (본문은 유지)
    // 예: "오늘 날씨 좋다 #여행 #힐링" → "오늘 날씨 좋다"
    caption = caption.replace(/([^\n#]+?)(\s*#[A-Za-z0-9가-힣_]+)+\s*$/gm, "$1");

    // 해시태그만 있는 줄 제거
    // 예: "#여행 #힐링 #카페" → ""
    caption = caption.replace(/^\s*(#[A-Za-z0-9가-힣_]+\s*)+$/gm, "");

    // 연속된 줄바꿈을 하나로 정리하고 앞뒤 공백 제거
    // 예: "\n\n\n안녕하세요\n\n" → "안녕하세요"
    caption = caption.replace(/\n{2,}/g, "\n").trim();

    return caption;
  };

  selectLearnedFeed = (id, caption) => {
    const copy = [...(this.state.selectedLearnedFeedCaptions || [])];
    const index = copy.findIndex((obj) => obj.instagram_media_id == id);

    if (index !== -1) {
      copy.splice(index, 1);
    } else {
      copy.push({
        instagram_access_token_seq: this.getActiveIgSeq(),
        instagram_media_id: id,
        caption,
      });
    }

    this.setState({
      selectedLearnedFeedCaptions: copy,
      selectedLearnedFeedCaptionsCnt: copy.length,
    });
  };

  selectLearnedFeedOnlyOne = (id, caption) => {
    const current = this.state.selectedLearnedFeedCaptions || [];
    const alreadySelected = current.some(obj => obj.instagram_media_id == id);

    let next = [];

    if (!alreadySelected) {
      next = [{
        instagram_access_token_seq: this.getActiveIgSeq(),
        instagram_media_id: id,
        caption
      }];
    }

    this.setState({
      selectedLearnedFeedCaptions: next,
      selectedLearnedFeedCaptionsCnt: next.length,
    });
  };

  handleInstagramAccountMessage = (e) => {
    // 필요하면 origin 체크 추가
    // if (e.origin !== "https://robomd.io" && e.origin !== "https://127.0.0.1:8092") return;

    if (e.data && e.data.type === "refreshInstagramAccount") {
      const token_id = e.data.token_id;

      if (token_id) {
        this.loadInstagramAccountList(token_id);
      } else {
        this.loadInstagramAccountList();
      }

      return;
    }
  };

  formatDate = (timestamp) => {
    if (!timestamp) return "";

    const date = new Date(timestamp);

    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");

    return `${yyyy}.${mm}.${dd}`;
  };

  render() {
    const { 
      presetTitle, isDataLearningOn, cardsChecked, selectedInnerItems, 
      customTextInput, customItems, industry, target, language, objective, 
      ctaPosition, ctaText, extraPrompt, learningData 
    } = this.state;

    // SelectBoxV2용 데이터 리스트
    const languageList = [
      { name: '한국어', code: 'ko' }, { name: '영어', code: 'en' },
      { name: '독일어', code: 'de' }, { name: '중국어(간체)', code: 'zh-cn' },
      { name: '중국어(번체)', code: 'zh-tw' }, { name: '일본어', code: 'ja' },
      { name: '베트남어', code: 'vi' }, { name: '프랑스어', code: 'fr' },
      { name: '스페인어', code: 'es' }, { name: '힌디어', code: 'hi' },
      { name: '아랍어', code: 'ar' }, { name: '벵골어', code: 'bn' },
      { name: '러시아어', code: 'ru' }, { name: '포르투갈어', code: 'pt' }
    ];

    const ctaPositionList = [
      { name: '문구 마지막 (하단)에 고정 추가', code: 'bottom' },
      { name: '문구 시작 (상단)에 고정 추가', code: 'top' }
    ];

    return (
      <>
        <div className="main-wrapper robo-md-copywriter-setting-page" id="page-wrapper" style={{ height: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: '#f4f7f9', fontFamily: "'Noto Sans KR', sans-serif" }}>
          <div className="robo-md-copywriter">
            <style>{`
              .robo-md-copywriter-setting-page {
                --primary-mint: #00e2e6;
                --primary-mint-hover: #00bfc2;
                --deep-navy: #0A1A2F;
                --deep-navy-hover: #111C3A;
                --bg-color: #f4f7f9; 
                --border-color: #e5e7eb;
                --text-main: #0A1A2F;
                --text-sub: #6b7280;
                --white: #ffffff;
                --radius-md: 12px;
                --radius-sm: 8px;
              }

              .robo-md-copywriter-setting-page { padding-top: 72px !important; max-width: 100% !important; box-sizing: border-box; overflow: hidden; }

              /* Base Styles & Typography */
              .robo-md-copywriter * { margin: 0; padding: 0; box-sizing: border-box; font-family: 'Noto Sans KR', sans-serif; }
              .robo-md-copywriter { background-color: #f4f7f9; color: #0A1A2F; line-height: 1.6; height: 100%; min-height: 0; display: flex; flex-direction: column; overflow: hidden; }

              /* Layout */
              .robo-md-copywriter .main-content {
                flex: 1;
                min-height: 0;
                overflow-y: auto;
                overflow-x: hidden;
                padding: 40px max(40px, calc((100% - 900px) / 2));
                max-width: none;
                margin: 0;
                width: 100%;
              }

              /* Header - InstagramCreateAiImageAutomation_v2 기준 */
              .robo-md-copywriter .header-row { position: sticky; top: 0; z-index: 1000; display: flex; align-items: center; justify-content: space-between; flex-shrink: 0; background: var(--white); padding: 16px 32px; border-bottom: 1px solid var(--border-color); box-shadow: 0 2px 10px rgba(10, 26, 47, 0.05); }
              .robo-md-copywriter .header-title-wrap { display: flex; align-items: center; gap: 12px; min-width: 0; }
              .robo-md-copywriter .header-title-wrap::before { content: ''; width: 6px; height: 48px; background: var(--primary-mint); border-radius: 3px; display: block; flex-shrink: 0; }
              .robo-md-copywriter .header-title-text { display: flex; flex-direction: column; justify-content: center; min-width: 0; }
              .robo-md-copywriter .page-title { font-size: 24px; font-weight: 700; line-height: 1.2; margin: 0; color: var(--deep-navy); letter-spacing: -0.02em; }
              .robo-md-copywriter .page-subtitle { font-size: 14px; color: var(--text-sub); margin-top: 5px; line-height: 1.35; font-weight: 500; }
              .robo-md-copywriter .header-actions { display: flex; align-items: center; gap: 12px; flex-shrink: 0; }

              .robo-md-copywriter .automation-menu-wrap {
                position: relative;
              }

              .robo-md-copywriter .automation-menu {
                position: absolute;
                top: calc(100% + 8px);
                right: 0;
                z-index: 1200;
                min-width: 220px;
                padding: 6px;
                background: #ffffff;
                border: 1px solid #e5e7eb;
                border-radius: 8px;
                box-shadow: 0 12px 30px rgba(10, 26, 47, 0.16);
              }

              .robo-md-copywriter .automation-menu-item {
                width: 100%;
                min-height: 42px;
                padding: 10px 12px;
                border: none;
                border-radius: 6px;
                background: transparent;
                color: #0A1A2F;
                text-align: left;
                font-size: 14px;
                font-weight: 700;
                cursor: pointer;
              }

              .robo-md-copywriter .automation-menu-item:hover {
                background: #f0fdfe;
                color: #0A1A2F;
              }
              
              /* Preset Title Input */
              .robo-md-copywriter .preset-title-box { background: white; border-radius: 12px; padding: 24px 28px; margin-bottom: 32px; border: 2px solid #e5e7eb; box-shadow: 0 2px 8px rgba(10, 26, 47, 0.03); transition: all 0.2s; display: flex; flex-direction: column; gap: 8px; }
              .robo-md-copywriter .preset-title-box:focus-within { border-color: #00e2e6; box-shadow: 0 4px 12px rgba(0, 226, 230, 0.1); }
              .robo-md-copywriter .preset-input-label { font-size: 13px; font-weight: 700; color: #00e2e6; letter-spacing: 0.5px; display: block; }
              .robo-md-copywriter .preset-name-input { width: 100%; border: none; border-bottom: 2px solid #e5e7eb; padding-bottom: 12px; margin-top: 4px; font-size: 24px; font-weight: 700; color: #0A1A2F; outline: none; background: transparent; transition: border-color 0.2s; }
              .robo-md-copywriter .preset-name-input:focus { border-bottom-color: #00e2e6; }
              .robo-md-copywriter .preset-name-input::placeholder { color: #d1d5db; font-weight: 600; }

              /* TextInput Component Override Styles */
              .robo-md-copywriter .form-group .common_text_input input { width: 100%; padding: 12px 16px; border: 2px solid #e5e7eb; border-radius: 8px; font-size: 14px; transition: all 0.2s; background: white; color: #0A1A2F; }
              .robo-md-copywriter .form-group .common_text_input input:focus { outline: none; border-color: #00e2e6; box-shadow: 0 0 0 3px rgba(0, 226, 230, 0.1); }

              /* Cards */
              .robo-md-copywriter .card { background: white; border: 1px solid #e5e7eb; border-radius: 12px; padding: 32px; margin-bottom: 24px; box-shadow: 0 2px 8px rgba(10, 26, 47, 0.02); }
              .robo-md-copywriter .card-title { font-size: 18px; font-weight: 700; margin-bottom: 8px; display: flex; align-items: center; gap: 8px; color: #0A1A2F; flex-wrap: wrap;}
              .robo-md-copywriter .card-desc { font-size: 14px; color: #6b7280; margin-bottom: 24px; border-bottom: 2px solid #f9fafb; padding-bottom: 16px; }
              
              .robo-md-copywriter .badge-common { background: #e5e7eb; color: #4b5563; font-size: 11px; padding: 4px 8px; border-radius: 4px; font-weight: 700; white-space: nowrap;}
              .robo-md-copywriter .badge-mint { background: #00e2e6; color: #0A1A2F; font-size: 11px; padding: 4px 8px; border-radius: 4px; font-weight: 700; white-space: nowrap;}
              .robo-md-copywriter .badge-opt { background: #f3f4f6; color: #6b7280; font-size: 11px; padding: 4px 8px; border-radius: 4px; font-weight: 700; white-space: nowrap;}

              /* Form Controls */
              .robo-md-copywriter .form-group { margin-bottom: 24px; }
              .robo-md-copywriter .m-b-24 { margin-bottom: 24px; }
              .robo-md-copywriter .form-label { display: block; font-weight: 600; font-size: 14px; margin-bottom: 8px; color: #0A1A2F; }
              .robo-md-copywriter .form-desc { font-size: 13px; color: #6b7280; margin-bottom: 12px; line-height: 1.5; }
              .robo-md-copywriter .form-control { width: 100%; padding: 12px 16px; border: 2px solid #e5e7eb; border-radius: 8px; font-size: 14px; transition: all 0.2s; background: white; color: #0A1A2F; }
              .robo-md-copywriter .form-control:focus { outline: none; border-color: #00e2e6; box-shadow: 0 0 0 3px rgba(0, 226, 230, 0.1); }
              .robo-md-copywriter textarea.form-control { resize: vertical; min-height: 80px; }
              
              .robo-md-copywriter .grid-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; }
              .robo-md-copywriter .flex-between { display: flex; justify-content: space-between; align-items: center; }

              /* Radio Grid */
              .robo-md-copywriter .radio-grid { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 16px; }
              .robo-md-copywriter .radio-label { display: flex; flex-direction: column; align-items: center; text-align: center; gap: 10px; cursor: pointer; padding: 24px 16px; border: 2px solid #e5e7eb; border-radius: 8px; background: white; transition: all 0.2s; }
              .robo-md-copywriter .radio-label:hover { border-color: #00e2e6; }
              .robo-md-copywriter .radio-label input[type="radio"] { width: 18px; height: 18px; accent-color: #00e2e6; margin-bottom: 4px; }
              .robo-md-copywriter .radio-label:has(input:checked) { border-color: #00e2e6; background: rgba(0, 226, 230, 0.02); box-shadow: 0 0 0 1px #00e2e6;}
              .robo-md-copywriter .radio-label .text-main { font-weight: 600; font-size: 14px; color: #0A1A2F; margin-bottom: 4px; }
              .robo-md-copywriter .radio-label .text-sub { font-size: 12px; color: #6b7280; line-height: 1.4; }

              /* Toggle Switch & Row */
              .robo-md-copywriter .toggle-row { display: flex; flex-direction: column; padding: 20px; background: #f9fafb; border-radius: 8px; margin-bottom: 16px; border: 1px solid #e5e7eb; transition: all 0.3s;}
              .robo-md-copywriter .toggle-row.active { background: white; border-color: #00e2e6; box-shadow: 0 2px 8px rgba(0, 226, 230, 0.1); }
              .robo-md-copywriter .toggle-header { display: flex; justify-content: space-between; align-items: center; width: 100%; gap: 16px; cursor: pointer; }
              .robo-md-copywriter .toggle-info { flex: 1; }
              .robo-md-copywriter .toggle-info strong { display: block; font-size: 15px; color: #0A1A2F; margin-bottom: 4px; }
              .robo-md-copywriter .toggle-info span { font-size: 13px; color: #6b7280; display: block; line-height: 1.4; }
              
              .robo-md-copywriter .toggle-switch { position: relative; width: 52px; height: 28px; background: #d1d5db; border-radius: 14px; transition: all 0.3s; flex-shrink: 0; }
              .robo-md-copywriter .toggle-switch.on { background: #00e2e6; }
              .robo-md-copywriter .toggle-knob { position: absolute; top: 3px; left: 3px; width: 22px; height: 22px; background: white; border-radius: 50%; transition: all 0.3s; box-shadow: 0 2px 4px rgba(0,0,0,0.1); }
              .robo-md-copywriter .toggle-switch.on .toggle-knob { left: auto; right: 3px; }

              .robo-md-copywriter .expandable-content { display: none; padding-top: 20px; margin-top: 20px; border-top: 1px dashed #e5e7eb; width: 100%; animation: fadeIn 0.3s ease; }
              .robo-md-copywriter .toggle-row.active .expandable-content { display: block; }

              /* Multi-Select Reference Cards */
              .robo-md-copywriter .multi-ref-grid { display: flex; flex-direction: column; gap: 16px; }
              .robo-md-copywriter .multi-ref-card { background: white; border: 2px solid #e5e7eb; border-radius: 12px; padding: 20px; transition: all 0.2s; position: relative; }
              .robo-md-copywriter .multi-ref-card.checked { border-color: #00e2e6; background: rgba(0, 226, 230, 0.02); }
              
              .robo-md-copywriter .ref-header { display: flex; align-items: center; gap: 12px; cursor: pointer; flex-wrap: wrap; }
              .robo-md-copywriter .ref-header input[type="checkbox"] { width: 20px; height: 20px; accent-color: #00e2e6; cursor: pointer; }
              .robo-md-copywriter .ref-title { font-weight: 600; font-size: 16px; color: #0A1A2F; }
              
              .robo-md-copywriter .ref-inner { display: none; margin-top: 16px; padding-top: 16px; border-top: 1px dashed #d1d5db; }
              .robo-md-copywriter .multi-ref-card.checked .ref-inner { display: block; animation: fadeIn 0.3s ease; }

              /* Selected Inner Cards & Delete Button */
              .robo-md-copywriter .inner-item-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
              .robo-md-copywriter .inner-item { border: 1px solid #e5e7eb; border-radius: 8px; padding: 20px; cursor: pointer; background: white; position: relative; }
              .robo-md-copywriter .inner-item.selected { border-color: #00e2e6; box-shadow: 0 0 0 1px #00e2e6; background: rgba(0, 226, 230, 0.05); }
              .robo-md-copywriter .inner-item-text { font-size: 13px; color: #0A1A2F; line-height: 1.6; white-space: pre-wrap; word-break: break-all; }
              .robo-md-copywriter .inner-item-tag { font-size: 11px; padding: 4px 8px; border-radius: 4px; font-weight: 600; margin-bottom: 8px; display: inline-block; }

              /* 삭제 (X) 버튼 */
              .robo-md-copywriter .delete-btn { position: absolute; top: 10px; right: 10px; background: #f3f4f6; color: #6b7280; border: none; width: 24px; height: 24px; border-radius: 50%; display: flex; align-items: center; justify-content: center; cursor: pointer; font-size: 14px; font-weight: bold; transition: all 0.2s; }
              .robo-md-copywriter .delete-btn:hover { background: #fee2e2; color: #dc2626; }

              /* Buttons */
              .robo-md-copywriter .btn-container { display: flex; justify-content: flex-end; gap: 12px; margin-top: 32px; padding-top: 24px; border-top: 1px solid #e5e7eb; }
              
              .btn {
                height: 42px;
                padding: 0 20px;
                border-radius: var(--radius-sm);
                font-size: 14px;
                font-weight: 700;
                cursor: pointer;
                border: none;
                transition: 0.2s;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                gap: 6px;
                white-space: nowrap;
              }
              .btn:focus {
                box-shadow: 0 0 0 0 transparent !important;
              }

              .robo-md-copywriter .btn-outline { background: #FFF; border: 1px solid #d1d5db; color: #4b5563; }
              .robo-md-copywriter .btn-outline:hover { background: #f0fdfe; border-color: #00e2e6; color: #0A1A2F; }
              .robo-md-copywriter .btn-secondary { background: var(--deep-navy); color: var(--white); box-shadow: 0 2px 8px rgba(10, 26, 47, 0.2); }
              .robo-md-copywriter .btn-secondary:hover { background: var(--deep-navy-hover); color: var(--white); transform: translateY(-1px); }
              .robo-md-copywriter .btn-secondary:active { background: var(--deep-navy-hover) !important; color: var(--white) !important; transform: translateY(-1px) !important; }
              .robo-md-copywriter .btn-primary { 
                background: #00e2e6;
                color: #4b5563;
                box-shadow: 0 2px 8px rgba(0, 226, 230, 0.2);
              }
              .robo-md-copywriter .btn-primary:hover {
                background: #00bfc2;
                color: #4b5563;
                transform: translateY(-1px);
              }
              .robo-md-copywriter .btn-primary:active {
                background: #00bfc2 !important;
                background-color: #00bfc2 !important;
                color: #4b5563 !important;
                transform: translateY(-1px) !important;
              }

              .robomd-list {
                background: #f9fafb;
                border-radius: 12px;
                padding: 16px;
                margin-top: 16px;

                .robomd-item {
                  width: 100%;
                  padding: 12px 16px;
                  margin-bottom: 8px;
                  background: #fff;
                  border: 1px solid #e5e7eb;
                  border-radius: 8px;
                  text-align: left;
                  cursor: pointer;
                  transition: all .2s;
                  font-size: 14px;
                  white-space: pre-line;
                }

                .robomd-item:last-of-type {
                  margin-bottom: 0px !important;
                }
              }
              
              .robomd-item:hover { 
                border-color: var(--primary-mint); 
                box-shadow: 0 4px 12px rgba(0, 226, 230, 0.05); 
                background: #f9fafb; 
              }
              .robomd-item.active {
                box-shadow: 0 0 0 1px #00e2e6;
                background: linear-gradient(135deg,#eff6ff 0%,rgba(0, 226, 230, 0.05) 100%);
                border-color: var(--primary-mint);
                color: #0A1A2F;
                font-weight: 600;
              }

              .robo-md-copywriter-setting-page .background-white { background-color: var(--white) !important; }
              
              @keyframes fadeIn { from { opacity: 0; transform: translateY(-5px); } to { opacity: 1; transform: translateY(0); } }

              /* Responsive Media Queries */
              @media (max-width: 800px) {
                  @supports (height: 100dvh) {
                    .robo-md-copywriter-setting-page { height: 100dvh !important; }
                  }
                  #page-wrapper.robo-md-copywriter-setting-page { padding: 60px 0px 72px 0px !important; }
                  .robo-md-copywriter .header-row { flex-direction: column; align-items: stretch; padding: 16px; gap: 16px; }
                  .robo-md-copywriter .header-actions { flex-direction: column; width: 100%; }
                  .robo-md-copywriter .header-actions > * { width: 100%; }
                  .robo-md-copywriter .automation-menu-wrap > .btn { width: 100%; }
                  .robo-md-copywriter .automation-menu { left: 0; right: 0; min-width: 0; }
                  .robo-md-copywriter .header-title-wrap::before { height: 46px; }
                  .robo-md-copywriter .main-content { padding: 24px 16px; }
                  .robo-md-copywriter .page-title { font-size: 22px; }
                  .robo-md-copywriter .page-subtitle { font-size: 13px; }
                  
                  .robo-md-copywriter .preset-title-box { padding: 20px 16px; margin-bottom: 24px; }
                  .robo-md-copywriter .preset-name-input { font-size: 20px; padding-bottom: 8px; }
                  
                  .robo-md-copywriter .card { padding: 24px 20px; margin-bottom: 16px; }
                  .robo-md-copywriter .card-title { font-size: 16px; }
                  
                  .robo-md-copywriter .grid-2, .robo-md-copywriter .radio-grid, .robo-md-copywriter .inner-item-grid { grid-template-columns: 1fr; gap: 12px; }
                  
                  .robo-md-copywriter .flex-between { flex-direction: column; align-items: flex-start; gap: 10px; }
                  .robo-md-copywriter .flex-between select { width: 100% !important; }
                  
                  .robo-md-copywriter .ref-header > div { flex: 1 1 100%; min-width: 0; }

                  .robo-md-copywriter .btn-container { flex-direction: column-reverse; gap: 12px; margin-top: 24px; }
                  .robo-md-copywriter .btn-container .btn { width: 100%; padding: 14px; }

                  .robo-md-copywriter .multi-ref-card .common_checkbox { justify-content: flex-start; }
                  
                  div:has(#ctaPosition_select) { width: 100% !important; }
              }
            `}</style>

            <div className="header-row">
              <div className="header-title-wrap">
                <div className="header-title-text">
                  <h1 className="page-title">AI 카피라이터 설정</h1>
                  <p className="page-subtitle">피드 문구를 생성하기 위한 AI 환경과 브랜드 맞춤 규칙을 설정합니다.</p>
                </div>
              </div>
              <div className="header-actions">
                <div
                  className="automation-menu-wrap"
                  ref={this.automationMenuRef}
                >
                  <button
                    className="btn btn-outline"
                    type="button"
                    disabled={this.state.isSavingPreset}
                    onClick={() => this.setState((prevState) => ({
                      automationMenuOpen: !prevState.automationMenuOpen,
                    }))}
                  >
                    저장 후 자동화 설정
                    {/* <span aria-hidden="true">▾</span> */}
                  </button>

                  {this.state.automationMenuOpen && (
                    <div className="automation-menu" role="menu">
                      <button
                        className="automation-menu-item"
                        type="button"
                        role="menuitem"
                        onClick={() => this.handleSaveAndGoAutomation("AI_IMAGE")}
                      >
                        AI 이미지 자동화 설정
                      </button>
                      <button
                        className="automation-menu-item"
                        type="button"
                        role="menuitem"
                        onClick={() => this.handleSaveAndGoAutomation("PRODUCT")}
                      >
                        상품 자동화 설정
                      </button>
                    </div>
                  )}
                </div>

                <button
                  className="btn btn-secondary"
                  type="button"
                  onClick={this.handleSaveAndRunPreset}
                  disabled={this.state.isSavingPreset}
                >
                  저장 후 즉시 실행
                </button>
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={this.handleSavePreset}
                  disabled={this.state.isSavingPreset}
                >
                  저장
                </button>
              </div>
            </div>

            <main className="main-content">
              <div className="preset-title-box">
                <label htmlFor="presetTitle" className="preset-input-label">설정 제목</label>
                {/* 원본 소스의 input 태그로 복구 완료 */}
                <input 
                  type="text" 
                  id="presetTitle" 
                  className="preset-name-input clear-placeholder" 
                  data-placeholder={this.state.suggestedPresetTitle}
                  value={presetTitle || ''}
                  onChange={(e) => this.handleStateChange('presetTitle', e.target.value)}
                  onFocus={this.handleFocus}
                  onBlur={this.handleBlur}
                  placeholder={this.state.suggestedPresetTitle} 
                />
              </div>

              <div className="card" data-instagram-tutorial="copy-setting-target">
                <div className="card-title">타겟 및 목적 설정 <span className="badge-common">공통 적용</span></div>
                <p className="card-desc">AI가 문구를 생성하기 위해 알아야 할 기본적인 핵심 정보입니다.</p>
                
                <div className="form-group">
                  <label className="form-label">업종 특성</label>
                  <TextInput 
                    id="industry"
                    value={industry || ''}
                    placeholder="예: 헤어/뷰티 살롱, 패션/의류 쇼핑몰"
                    onChange={(e, val) => this.handleStateChange('industry', val)}
                    padding="12px 16px"
                    height="46px"
                  />
                </div>

                <div className="grid-2">
                  <div className="form-group">
                    <label className="form-label">주요 타겟 고객 (Target)</label>
                    <TextInput 
                      id="target"
                      value={target || ''}
                      placeholder="예: 트렌드에 민감한 20-30대 여성"
                      onChange={(e, val) => this.handleStateChange('target', val)}
                      padding="12px 16px"
                      height="46px"
                    />
                  </div>
                  {/* <div className="form-group"> */}
                  <div className="m-b-24">
                    <label className="form-label">생성 언어</label>
                    <SelectBoxV2 
                      id="language_select"
                      list={languageList}
                      optionTexttName="name"
                      optionValuetName="code"
                      selectedValue={language}
                      onClickOption={(text, value) => this.handleStateChange('language', value)}
                      pageWrapperName="page-wrapper"
                      width="100%"
                      height="46px"
                    />
                  </div>
                </div>

                <div className="form-group" style={{ marginBottom: 0 }}>
                  <label className="form-label">생성 목적 (Objective)</label>
                  <textarea 
                    className="form-control" 
                    rows="2" 
                    value={objective || ''} 
                    onChange={(e) => this.handleStateChange('objective', e.target.value)} 
                    placeholder="예: 이번 시즌 신상품의 소재감을 강조하고, 방문을 유도하고 싶습니다."
                  ></textarea>
                </div>
              </div>

              <div className="card" data-instagram-tutorial="copy-setting-prompt">
                <div className="card-title">AI 추가 명령 프롬프트 <span className="badge-opt">선택 사항</span></div>
                <p className="card-desc">기본적인 마케팅 프롬프트는 이미 시스템에 내장되어 있습니다. 고객님만의 특별한 지시사항이 있다면 이곳에 추가해 주세요.</p>
                
                <div className="form-group" style={{ marginBottom: 0 }}>
                  <textarea 
                    className="form-control" 
                    rows="3" 
                    value={extraPrompt || ''}
                    onChange={(e) => this.handleStateChange('extraPrompt', e.target.value)}
                    placeholder="예: 첫 문장은 무조건 시선을 끄는 감탄사로 시작해줘. 이모지는 본문 중간중간에 하나씩만 넣어줘."
                  ></textarea>
                </div>
              </div>

              <div className="card" data-instagram-tutorial="copy-setting-cta">
                <div className="card-title">고정 / 필수 포함 행동 유도 문구 (CTA) <span className="badge-opt">선택 사항</span></div>
                <p className="card-desc">생성된 글의 상단이나 하단에 무조건 들어갈 예약 링크, 인사말 등의 안내 사항을 적어주세요. 입력하지 않아도 무방합니다.</p>
                
                {/* <div className="form-group" style={{ marginBottom: 0 }}> */}
                <div>
                  <div className="flex-between" style={{ marginBottom: '8px' }}>
                    <label className="form-label" style={{ marginBottom: 0, color: '#6b7280' }}>첨부 위치 선택</label>
                    <SelectBoxV2
                      id="ctaPosition_select"
                      className="background-white"
                      list={ctaPositionList}
                      optionTexttName="name"
                      optionValuetName="code"
                      selectedValue={ctaPosition}
                      onClickOption={(text, value) => this.handleStateChange('ctaPosition', value)}
                      pageWrapperName="page-wrapper"
                      width="auto"
                      height="40px"
                      padding="6px 32px 6px 16px"
                    />
                  </div>
                  <textarea 
                    className="form-control" 
                    rows="2" 
                    value={ctaText || ''} 
                    onChange={(e) => this.handleStateChange('ctaText', e.target.value)} 
                    placeholder="예약 및 문의는 프로필 링크를 확인해주세요! 💌"
                  ></textarea>
                </div>
              </div>

              <div className="card" data-instagram-tutorial="copy-setting-voice">
                <div className="card-title">브랜드 보이스 <span className="badge-opt">선택 사항</span></div>
                <p className="card-desc"><strong>다중 체크한 스타일의 개수만큼 서로 다른 버전의 문구가 독립적으로 생성</strong>됩니다.</p>
                
                <div className="multi-ref-grid">
                  
                  {/* AI 브랜드 보이스 */}
                  <div className={`multi-ref-card ${cardsChecked['ref-basic'] ? 'checked' : ''}`} data-instagram-tutorial="copy-setting-voice-basic">
                    <div className="ref-header">
                      <CheckBox 
                        id="ref-basic"
                        checked={cardsChecked['ref-basic']}
                        onChangeCheck={(e) => this.handleCardCheck('ref-basic', e.target.checked)}
                      />
                      <label htmlFor="ref-basic" style={{ flex: 1, cursor: 'pointer' }}>
                        <div className="ref-title">AI 브랜드 보이스</div>
                        <div style={{ fontSize: '13px', color: '#6b7280', marginTop: '2px' }}>시스템에 내장된 최적화된 다양한 마케팅 말투를 AI가 생성합니다.</div>
                      </label>
                    </div>
                    <div className="ref-inner">
                      <div className="inner-item-grid">
                        <div className={`inner-item ${selectedInnerItems['ref-basic'] === 0 ? 'selected' : ''}`} onClick={() => this.handleInnerItemSelect('ref-basic', 0)}>
                          <span className="inner-item-tag" style={{ background: '#0A1A2F', color: '#00e2e6' }}>AI 자동 맞춤 (권장)</span>
                          <div className="inner-item-text">AI가 업종과 타겟을 분석하여 가장 적합하고 다양한 톤앤매너로 알아서 문구를 생성합니다.</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 내 기존 피드 AI 보이스 */}
                  <div className={`multi-ref-card ${cardsChecked['ref-myfeed'] ? 'checked' : ''}`} data-instagram-tutorial="copy-setting-voice-myfeed">
                    <div className="ref-header">
                      <CheckBox
                        id="ref-myfeed"
                        checked={cardsChecked['ref-myfeed']}
                        onChangeCheck={(e) => {
                          this.handleCardCheck('ref-myfeed', e.target.checked);

                          if (e.target.checked) {
                            const igSeq = this.getActiveIgSeq();
                            if (igSeq && (!this.state.feedCaptions || this.state.feedCaptions.length === 0)) {
                              this.fetchAllInstagramMedia(false, igSeq);
                            }
                          }
                        }}
                      />
                      <label htmlFor="ref-myfeed" style={{ flex: 1, cursor: 'pointer' }}>
                        <div className="ref-title">내 기존 피드 AI 보이스</div>
                        <div style={{ fontSize: '13px', color: '#6b7280', marginTop: '2px' }}>
                          내가 기존에 썼던 게시글의 고유한 말투와 감성을 AI가 학습하여 유사한 톤으로 작성합니다.
                        </div>
                      </label>
                    </div>

                    <div className="ref-inner" data-instagram-tutorial="copy-setting-voice-myfeed-detail">
                      {this.state.accountConnected ? (
                        <div>
                          <div style={{ marginBottom: 16 }}>
                            <label className="form-label" style={{ marginBottom: 8, display: "block" }}>
                              인스타그램 계정 선택
                            </label>
                            <SelectBoxV2
                              id="ig_account_select"
                              className="background-white"
                              tabIndex={0}
                              width="100%"
                              height="40px"
                              padding="8px 36px 8px 12px"
                              backgroundColor="#fff"
                              pageWrapperName="common-page-wrapper"
                              list={this.state.account_list || []}
                              optionTexttName="title"
                              optionValuetName="value"
                              selectedValue={this.getActiveIgSeq()}
                              onClickOption={this.onChangeAccount}
                            />
                          </div>

                          <div style={{ marginBottom: 8 }}>
                            <span style={{ fontSize: 15, fontWeight: 700, color: "#0A1A2F" }}>
                              학습 기준이 될 최근 게시물을 하나 선택해주세요.
                            </span>
                            {/* <span style={{ fontSize: 12, color: "#6b7280", marginLeft: 8 }}>
                              (선택한 개수: {this.state.selectedLearnedFeedCaptions?.length || 0}개)
                            </span> */}
                          </div>

                          <div
                            className="robomd-list"
                            style={{
                              marginTop: 0,
                              maxHeight: 240,
                              overflowY: "auto",
                              border: "1px solid #e5e7eb",
                              borderRadius: 6,
                              padding: 12,
                              backgroundColor: "#f9fafb",
                            }}
                          >
                            {this.state.feedCaptions && this.state.feedCaptions.length > 0 ? (
                              this.state.feedCaptions.map((obj) => (
                                <button
                                  key={obj.instagram_media_id}
                                  type="button"
                                  className={`robomd-item ${
                                    this.state.selectedLearnedFeedCaptions.some(
                                      (item) => item.instagram_media_id == obj.instagram_media_id
                                    )
                                      ? "active"
                                      : ""
                                  }`}
                                  // onClick={() => this.selectLearnedFeed(obj.instagram_media_id, obj.caption)}
                                  onClick={() => this.selectLearnedFeedOnlyOne(obj.instagram_media_id, obj.caption)}
                                >
                                  <div style={{fontSize: "14px",
                                    fontWeight: 700,
                                    // marginBottom: '8px'
                                  }}>{obj.caption}</div>
                                  {/* <span style={{
                                    fontSize: '12px',          
                                    fontWeight: 600,          
                                    background: '#f1f5f9',
                                    color: '#475569',
                                    padding: '4px 8px',
                                    borderRadius: '6px',       
                                  }}>
                                    {this.formatDate(obj.timestamp)}
                                  </span> */}
                                </button>
                              ))
                            ) : (
                              <div style={{ fontSize: 14, color: "#6b7280" }}>
                                불러온 피드 문구가 없습니다.
                              </div>
                            )}
                          </div>

                          <p style={{ fontSize: 12, color: "#6b7280", marginTop: 8, lineHeight: "1.6" }}>
                            {/* 선택한 피드 문구를 기반으로 AI가 말투와 감성을 참고합니다. */}
                            선택한 피드 문구를 분석하여 내 피드와 어울리는 문구를 작성합니다.
                          </p>
                        </div>
                      ) : (
                        <div
                          style={{
                            textAlign: 'center',
                            padding: '40px 20px',
                            background: 'white',
                            borderRadius: '8px',
                            border: '1px dashed #d1d5db'
                          }}
                        >
                          <div style={{ fontSize: '32px', marginBottom: '12px' }}>📱</div>
                          <p style={{ fontSize: '16px', fontWeight: '600', color: '#0A1A2F', marginBottom: '8px' }}>
                            인스타그램 계정이 연동되지 않았습니다.
                          </p>
                          <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '20px', lineHeight: '1.6' }}>
                            계정을 연동하면 반응이 좋았던 내 게시글을 AI가 학습합니다.<br />
                            <strong>자주 쓰는 단어, 이모지 패턴, 특유의 감성</strong>까지<br />
                            분석하여 내 피드와 어울리는 문구를 작성합니다.
                          </p>
                          <button
                            className="btn btn-primary"
                            style={{ padding: '12px 24px', fontSize: '14px' }}
                            onClick={this.handleConnectAccount}
                          >
                            인스타그램 계정 연동하기
                          </button>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* 커스텀 뱅크 AI 보이스 */}
                  <div className={`multi-ref-card ${cardsChecked['ref-custom'] ? 'checked' : ''}`} data-instagram-tutorial="copy-setting-voice-custom">
                    <div className="ref-header">
                      <CheckBox 
                        id="ref-custom"
                        checked={cardsChecked['ref-custom']}
                        onChangeCheck={(e) => this.handleCardCheck('ref-custom', e.target.checked)}
                      />
                      <label htmlFor="ref-custom" style={{ flex: 1, cursor: 'pointer' }}>
                        <div className="ref-title">커스텀 뱅크 AI 보이스</div>
                        <div style={{ fontSize: '13px', color: '#6b7280', marginTop: '2px' }}>평소 저장해둔 특정 피드 문구를 AI가 학습하여 유사한 톤으로 작성합니다.</div>
                      </label>
                    </div>
                    <div className="ref-inner" data-instagram-tutorial="copy-setting-voice-custom-detail">
                      <div style={{ background: '#f9fafb', border: '1px dashed #d1d5db', borderRadius: '8px', padding: '20px', marginBottom: '24px' }}>
                        <textarea 
                          id="customText" 
                          className="form-control" 
                          rows="3" 
                          placeholder="따라하고 싶은 피드 문구를 여기에 복사해 넣으세요." 
                          style={{ fontSize: '13px', padding: '12px' }}
                          value={customTextInput || ''}
                          onChange={(e) => this.handleStateChange('customTextInput', e.target.value)}
                        ></textarea>
                        <div style={{ textAlign: 'right', marginTop: '12px' }}>
                          <button className="btn btn-outline" style={{ padding: '6px 16px', fontSize: '12px' }} onClick={this.handleAddCustomRef}>+ 뱅크에 추가</button>
                        </div>
                      </div>
                      <div className="inner-item-grid" id="custom-grid">
                        {customItems.map((item, idx) => (
                          <div key={item.custom_reference_seq || idx} className={`inner-item ${selectedInnerItems['ref-custom'] === idx ? 'selected' : ''}`} onClick={() => this.handleInnerItemSelect('ref-custom', idx)}>
                            <button className="delete-btn" onClick={(e) => this.handleDeleteCustomRef(e, idx)}>✕</button>
                            <div className="inner-item-text">{item.custom_reference_text}</div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                </div>
              </div>

              <div className="card" style={{ marginBottom: 0 }} data-instagram-tutorial="copy-setting-learning">
                <div className="card-title">이미지 및 상품데이터 AI 학습 가중치 <span className="badge-mint">AI Engine</span></div>
                <p className="card-desc">등록된 상품의 어떤 정보를 기반으로 AI가 분석하고 글을 쓸지 결정합니다. (기본: 학습 안 함)</p>
                
                <div className={`toggle-row ${isDataLearningOn ? 'active' : ''}`} id="toggle-data">
                  <div className="toggle-header" onClick={this.toggleDataLearning}>
                    <div className="toggle-info">
                      <strong>데이터 학습 기능 켜기</strong>
                      <span>이 기능을 켜면 상품명 텍스트나 등록된 사진을 AI가 인지하여 문구에 반영합니다.</span>
                    </div>
                    <div className={`toggle-switch ${isDataLearningOn ? 'on' : ''}`}>
                      <div className="toggle-knob"></div>
                    </div>
                  </div>

                  <div className="expandable-content">
                    <div className="radio-grid">
                      <label className="radio-label">
                        <input 
                          type="radio" 
                          name="learning_data" 
                          checked={learningData === 'multi'} 
                          onChange={() => this.handleStateChange('learningData', 'multi')} 
                        />
                        <div>
                          <div className="text-main">멀티모달 매핑</div>
                          <div className="text-sub">사진 정보 분석 + 상품명</div>
                        </div>
                      </label>
                      <label className="radio-label">
                        <input 
                          type="radio" 
                          name="learning_data" 
                          checked={learningData === 'text'} 
                          onChange={() => this.handleStateChange('learningData', 'text')} 
                        />
                        <div>
                          <div className="text-main">텍스트 단일 매핑</div>
                          <div className="text-sub">상품선택시 상품명 중심</div>
                        </div>
                      </label>
                      <label className="radio-label">
                        <input 
                          type="radio" 
                          name="learning_data" 
                          checked={learningData === 'image'} 
                          onChange={() => this.handleStateChange('learningData', 'image')} 
                        />
                        <div>
                          <div className="text-main">이미지 단일 매핑</div>
                          <div className="text-sub">사진 정보 분석</div>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className="btn-container">
                <button className="btn btn-outline">초기화</button>
                <button className="btn btn-primary" onClick={() => {
                  this.handleSavePreset();
                }}>설정 저장</button>
              </div> */}

            </main>
          </div>
        </div>

        <RoboMDAICopywriterModal
          key={`copywriter-run-${this.state.runModalKey}`}
          isOpen={this.state.isRunModalOpen}
          onClose={this.closeRunModal}
          presetMode="FIXED"
          fixedPresetSeq={this.state.runPresetSeq || this.state.preset_seq}
          historyEnabled={false}
          onContentRegister={this.handleSelectedContentRegister}
          contentRegisterButtonLabel="선택 문구로 콘텐츠 등록하러 가기"
        />

        {/* 로딩, 저장 다이얼로그 */
          this.state.save_dialog_show_state === true &&
          <SaveDialogV2
              content={this.state.save_dialog_content}
              button_list={this.state.save_dialog_button_list}
          />
        }
        {/* 경고 다이얼로그 */
          this.state.warning_dialog_show_state === true &&
          <WarningDialog
              content={this.state.warning_dialog_content}
              button_list={this.state.warning_dialog_button_list}
          />
        }
      </>
    );
  }
}

export default InstagramCopywriterSetting;